var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_vm.loading ? _c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("이벤트")])]), _c('div', {
    staticClass: "contents-area__inner"
  }, [_c('div', {
    staticClass: "my-md-n10px"
  }, [_c('v-row', _vm._l(_vm.boards, function (board) {
    return _c('v-col', {
      key: board._id,
      attrs: {
        "cols": "6",
        "md": "4"
      }
    }, [_c('div', {
      staticClass: "py-md-10px cursor-pointer event-card",
      on: {
        "click": function click($event) {
          return _vm.rows(board);
        }
      }
    }, [_c('div', {
      staticClass: "border"
    }, [_c('v-img', {
      staticClass: "event-card__image",
      attrs: {
        "src": board.thumb,
        "max-width": "500",
        "aspect-ratio": 500 / 500,
        "contain": ""
      }
    })], 1), _c('div', {
      staticClass: "text-center py-12px py-md-16px"
    }, [_c('div', {
      staticClass: "tit tit--xs text-truncate"
    }, [_vm._v(_vm._s(board.subject))]), _c('div', {
      staticClass: "font-size-16 font-size-md-18 mt-6px"
    }, [_vm._v(_vm._s("".concat(_vm.$dayjs(board.display.startDate).format("YYYY.MM.DD"), " ~ ").concat(board.display.endDate ? _vm.$dayjs(board.display.endDate).format("YYYY.MM.DD") : "상시진행")))])])])]);
  }), 1)], 1)]), _c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }), _c('div', {
    staticClass: "contents-area__inner"
  }, [_c('router-board', {
    attrs: {
      "code": "event",
      "skin": "event"
    }
  })], 1)])]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }